import { useEffect } from 'react';

const useKeypress = (key, isOpen, onClose) => {
    useEffect(() => {
        const handleKeypress = (event) => {
            if (isOpen && event.key === key) {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeypress);
        return () => {
            window.removeEventListener('keydown', handleKeypress);
        };
    }, [key, isOpen, onClose]);
};

export default useKeypress;
